import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SLIDES = [
  {
    href: 'https://www.swindia.com/swilerp-cloud/?utm_source=swilshare&utm_medium=referral&utm_campaign=swilerp_cloud',
    src: 'https://swilindiacdn.blob.core.windows.net/swilshare/SwilERP-Cloud.png',
    alt: 'SwilERP Cloud — Cloud-based ERP for retail and wholesale',
  },
  {
    href: 'https://www.swindia.com/retailgraph-software/?utm_source=swilshare&utm_medium=referral&utm_campaign=retailgraph_erp',
    src: 'https://swilindiacdn.blob.core.windows.net/swilshare/RetailGraph-Banner.png',
    alt: 'RetailGraph — Retail management software',
  },
  {
    href: 'https://www.swindia.com/swilerp-software/?utm_source=swilshare&utm_medium=referral&utm_campaign=swilerp_pharmacy_software',
    src: 'https://swilindiacdn.blob.core.windows.net/swilshare/slide-01.jpg',
    alt: 'SwilERP Software',
  },
  {
    href: 'https://www.swindia.com/mobile-app-solutions/?utm_source=swilshare&utm_medium=referral&utm_campaign=swilpos',
    src: 'https://swilindiacdn.blob.core.windows.net/swilshare/slide-02.jpg',
    alt: 'SwilPOS — Point of sale mobile app',
  },
  {
    href: 'https://www.swindia.com/mobile-app-solutions/?utm_source=swilshare&utm_medium=referral&utm_campaign=swilsort',
    src: 'https://swilindiacdn.blob.core.windows.net/swilshare/slide-03.jpg',
    alt: 'SwilSORT — Sorting and dispatch mobile app',
  },
  {
    href: 'https://www.swindia.com/mobile-app-solutions/?utm_source=swilshare&utm_medium=referral&utm_campaign=swildispatch',
    src: 'https://swilindiacdn.blob.core.windows.net/swilshare/slide-04.jpg',
    alt: 'SwilDISPATCH — Dispatch management app',
  },
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3500,
  pauseOnHover: true,
  arrows: false,
};

export function MarketingPanel() {
  return (
    <div className="marketing-panel">
      <Slider {...sliderSettings}>
        {SLIDES.map((slide) => (
          <div key={slide.href}>
            <a href={slide.href} target="_blank" rel="noreferrer">
              <img src={slide.src} alt={slide.alt} />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
}
